<template>
  <div id="like">
    <div class="box">
      <el-row>
        <el-col :span="3" align="center">
          <el-image class="cover" :src="serve + '/'+image" fit="cover"></el-image>
        </el-col>
        <el-col :span="18">
          <div>
            <div class="title lv2Text">{{title}}</div>
            <div class="price2">&yen;{{price}}</div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="padding-top:18px">
            <router-link :to="'/product/'+id">
              <el-button>查看详情</el-button>
            </router-link>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="box" style="margin-top: 20px;">
      <div class="title2 lv3Text">相似商品</div>
      <div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) of data" :key="index">
            <div class="item">
              <router-link :to="'/product/'+item.id">
                <el-image
                  class="cover2"
                  :src="serve + '/'+item.images"
                  fit="cover"
                ></el-image>
              </router-link>
              <div class="label">
                <router-link :to="'/product/'+item.id">{{item.title.slice(0,10)}}</router-link>
              </div>
              <div class="price">&yen;{{item.selling_price}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      id: null,
      title: null,
      price: null,
      image: null,
      data: null
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.user_location = "收藏的商品";
    this.$store.state.user_location2 = "相似商品";
    this.id = this.$route.query.id;
    this.title = this.$route.query.name;
    this.price = this.$route.query.price;
    this.image = this.$route.query.image;
    this.initData();
  },
  methods: {
    //
    initData() {
      this.axios
        .get(this.serve + "/personal/select_like", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            product_id: this.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
    }
  }
};
</script>
<style lang="scss">
#like {
  .title2 {
    font-size: 16px;
    margin: 0 10px 20px 0;
  }
  .box {
    .item {
      border: 1px solid #ddd;
      margin-bottom: 20px;
    }
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 20px;
  }
  .label {
    text-align: center;
    padding: 10px 0;
    a {
      color: #606266;
    }
  }
  .label:hover {
    text-decoration: underline;
  }
  .price {
    color: #e2211c;
    text-align: center;
    margin-bottom: 10px;
  }
  .cover {
    display: block;
    width: 90px;
    height: 90px;
    background-color: #eee;
    margin: 0 auto;
    background-position: center;
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
  .cover2 {
    display: block;
    width: 180px;
    height: 180px;
    background-color: #eee;
    margin: 0 auto;
    margin-top: 10px;
    background-position: center;
    background-size: auto 100%;
    transition: 0.3s;
    cursor: pointer;
    background-repeat: no-repeat;
  }
  .cover2:hover {
    background-size: auto 120%;
  }

  .title {
    font-size: 18px;
    line-height: 1.5em;
    margin-top: 15px;
  }
  .price2 {
    color: #e2211c;
    font-size: 16px;
    margin-top: 5px;
  }
}
</style>